import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
    indicator: {
        position: 'absolute',
        //backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        width: 24,
        height: 24,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        //borderRadius: '50%', // optional, if you want it circular
    },
    topCenter: {
        top: 4,
         width: 35,
        height: 35,
        left: '50%',
        transform: 'translateX(-50%)',
         filter: `
    drop-shadow(0 0 0 white)
    drop-shadow(0 0 2px white)
    drop-shadow(0 0 4px white)
    drop-shadow(0 0 6px white)
  `,
    },
    bottomLeft: {
        bottom: 4,
        left: 4,
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            // ✅ White glow / shadow effect
            filter: `
    drop-shadow(0 0 0 white)
    drop-shadow(0 0 2px white)
    drop-shadow(0 0 4px white)
    drop-shadow(0 0 6px white)
  `,
        },
    },
})

/**
 * Component to display Hi-Res or Low-Res indicator based on image variant type
 */
const ResolutionIndicator = ({ classes, variantType, position = 'topCenter' }) => {
    if (!variantType) {
        return null
    }

    const isHiRes = variantType.toLowerCase() === 'hi-res'
    const iconPath = isHiRes ? '/img/High_Res.svg' : '/img/Low_Res.svg'
    const altText = isHiRes ? 'High Resolution' : 'Low Resolution'

    const positionClass = position === 'bottomLeft' ? classes.bottomLeft : classes.topCenter

    return (
        <div className={`${classes.indicator} ${positionClass}`}>
            <img src={iconPath} alt={altText} />
        </div>
    )
}

ResolutionIndicator.propTypes = {
    classes: PropTypes.object.isRequired,
    variantType: PropTypes.string,
    position: PropTypes.oneOf(['topCenter', 'bottomLeft']),
}

export default withStyles(styles)(ResolutionIndicator)
